<template>
    <div class="card-container">

        <v-btn @click="deleteCard" color="error" style="right: -10px; top: -10px" fab small absolute top right>
            <v-icon>mdi-delete</v-icon>
        </v-btn>

        <div class="card-chip">
            <img src="@/assets/img/payment_card/card_chip.png" width="100%" />
        </div>

        <div class="card-number">
            <div class="number-section">****</div>
            <div class="number-section">****</div>
            <div class="number-section">****</div>
            <div class="number-section">{{card && card.last4 || '****'}}</div>
        </div>

        <div class="footer">

            <div class="holder">
                {{holder}}
            </div>

            <div class="brand-logo">
                <img :src="brandImg" width="100%"/>
            </div>

        </div>

        <kimsa-confirm
                ref="deleteModal"
                :title="$t('payment.delete_warning_title')"
                :content="$t('payment.delete_warning_content')"
                :loading="loadingDelete"
                :persistent="false"
                @confirm="deleteConfirm"
                :close-on-confirm="false"
        ></kimsa-confirm>

    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    import KimsaConfirm from "../KimsaConfirm";
    import {db} from '@/utils/Firebase'

    export default {
        name: "PaymentCard",
        components: {KimsaConfirm},
        props:{
            ownerId: {
                type: String,
                required: true
            },
           paymentMethod:{
               type: Object,
               required: true
           }
        },
        data(){
          return {
              loadingDelete: false
          }
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            deleteCard() {
                const vm = this
                vm.$refs.deleteModal.show()
            },
            async deleteConfirm() {
                const vm = this
                vm.loadingDelete = true
                await db.collection('users').doc(vm.ownerId)
                .update({
                    'stripeAccount.paymentMethod': null
                })
                vm.showSnackBar({
                    text: vm.$t('payment.delete_success'),
                    color: 'error'
                })
                vm.loadingDelete = false
            }
        },
        computed:{
            holder(){
                const vm = this
                if(!vm.paymentMethod || !vm.paymentMethod.billing_details) return ''
                return vm.paymentMethod.billing_details.name
            },
            card(){
                const vm = this
                return vm.paymentMethod && vm.paymentMethod.card || null
            },
            brandImg(){
                const vm = this
                if(!vm.card) return ''
                 /*
                 * American Express, Diners Club, Discover, JCB, MasterCard, UnionPay, Visa, or Unknown
                 * */
                switch(vm.card.brand){
                    case 'amex':
                        return require('@/assets/img/payment_card/american_express.png')
                    case 'diners':
                        return require('@/assets/img/payment_card/diners_club.png')
                    case 'discover':
                        return require('@/assets/img/payment_card/discover.png')
                    case 'jcb':
                        return require('@/assets/img/payment_card/jcb.png')
                    case 'mastercard':
                        return require('@/assets/img/payment_card/mastercard.png')
                    case 'visa':
                        return require('@/assets/img/payment_card/visa.png')
                    default:
                        return require('@/assets/img/payment_card/unknown.png')
                }

            }
        }
    }
</script>

<style scoped>

    @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,300;0,400;1,300&display=swap');


    .card-number,
    .holder{
        text-shadow: 1px 1px 3px rgba(0,0,0,.9);
    }

    .card-number{
      position: absolute;
      display: flex;
      justify-content: center;
      top: 25%;
      left: 0;
      padding: 10px;
      color: #fff;
      width: 100%;
    }

    .card-number .number-section{
        flex: 1;
        padding: 2px;
        text-align: center;
        font-size: 1em;
    }

    .holder{
      flex: 5;
      padding-left: 15px;
      font-family: 'Roboto Mono', monospace;
      font-size: 1em;
      font-weight: 500;
      color: white;
    }

    @media screen and (min-width: 321px){

      .card-number{
        top: 35%;
      }

      .holder{
        font-size: 1.8em;
      }

      .card-number .number-section{
        font-size: 1.8em;
      }
    }

    @media screen and (min-width: 500px){

      .holder{
        font-size: 2.5em;
      }

      .card-number{
        top: 40%;
      }

      .card-number .number-section{
        font-size: 2.5em;
      }
    }

    @media screen and (min-width: 700px){

      .card-number{
        top: 40%;
      }

      .card-number .number-section{
        font-size: 3em;
      }
    }

    .brand-logo{
        flex: 1;
        text-align: right;
    }

    .card-container{
        position: relative;
        background-color: var(--v-accent-base);
        border-radius: 10px;
        width: 100%;
        padding-top: 56.25%;
        background-image: url("../../../assets/img/payment_card/card_background.png");
        background-position: center;
        background-size: cover;
        box-shadow: 10px 10px 25px rgba(0,0,0,.4);
    }

    .card-chip{
        padding: 5px;
        position: absolute;
        width: 20%;
        top: 5px;
        left: 5px;
        filter: brightness(0.9);
    }

    .chip-spacer{
        flex: 7;
    }

    .footer{
      position: absolute;
      padding: 10px;
      align-items: center;
      bottom: 5px;
      display: flex;
      left: 0;
      width: 100%;
    }


</style>